module.exports = __webpack_public_path__ + "static/media/1_pl.e841d842.png";